import { render } from "./ExperienceBlock.vue?vue&type=template&id=5ad518ec&scoped=true"
import script from "./ExperienceBlock.vue?vue&type=script&lang=js"
export * from "./ExperienceBlock.vue?vue&type=script&lang=js"

import "./ExperienceBlock.vue?vue&type=style&index=0&id=5ad518ec&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad518ec"]])

export default __exports__